
// Store names
export const EMBEDDING_STORE = 'embeddings';
export const RESPONSE_STORE = 'responses';
export const MESSAGES_STORE = 'messages';
export const CACHE_STATS_STORE = 'cache_stats';
export const CACHE_RELATIONSHIPS_STORE = 'cache_relationships';

// Cache TTLs in milliseconds
export const CLIENT_CACHE_TTL = {
  EMBEDDING: 7 * 24 * 60 * 60 * 1000, // 7 days
  RESPONSE: 24 * 60 * 60 * 1000,      // 24 hours
  MESSAGES: 3 * 24 * 60 * 60 * 1000,  // 3 days
  FREQUENTLY_USED: 14 * 24 * 60 * 60 * 1000, // 14 days for frequently used items
  RARELY_USED: 12 * 60 * 60 * 1000,   // 12 hours for rarely used items
  // Add a shorter TTL for loading state to prevent cached loading states
  LOADING_STATE: 5 * 60 * 1000,       // 5 minutes
  // Additional cache TTL for error states to prevent constantly retrying failed operations
  ERROR_STATE: 30 * 60 * 1000,       // 30 minutes
};
